import {
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
  useRef,
} from "react"

import { isBrowser } from "../../utils/browser"

export const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect

// A hook to track first hover over an element
// adapted from: https://gist.github.com/gragland/a32d08580b7e0604ff02cb069826ca2f
export const useHoverOnce = () => {
  const [value, setValue] = useState(false)
  const handleMouseOver = useCallback(() => !value && setValue(true), [value])
  const ref = useRef()

  // Use a callback ref instead of useEffect so that event listeners
  // get changed in the case that the returned ref gets added to
  // a different element later. With useEffect, changes to ref.current
  // wouldn't cause a rerender and thus the effect would run again.
  const callbackRef = useCallback(
    node => {
      if (ref.current)
        ref.current.removeEventListener("mouseover", handleMouseOver)

      ref.current = node

      if (ref.current)
        ref.current.addEventListener("mouseover", handleMouseOver)
    },
    [handleMouseOver]
  )

  return [callbackRef, value]
}
